const SEO = [
	{
		page: "home",
		description:
			"Azerty Labs (2020–2022) • a Brest-based lab exploring embedded AI inside the tight constraints of Eurorack hardware, built before generative AI reached the mainstream. Archived hardware work by Chloé Lavrat: MIDI-to-CV interfaces, audio bridges, and compact power supplies for on-module compute.",
		keywords: [
			"embedded AI",
			"edge machine learning",
			"eurorack modules",
			"on-device inference",
			"synthesizer design",
			"hardware engineering",
			"modular synthesizer",
			"MIDI to CV converter",
			"eurorack power supply",
			"audio interface design",
			"TensorFlow Lite Micro",
			"microcontroller ML",
			"PCB design",
			"Chloé Lavrat"
		],
	},
];

export default SEO;
